export default __webpack_public_path__ + "static/media/05-identify-non-customers.a70d67d0.png";